import { typography } from '@shared/tokens/typography.stylex';
import { anatomy } from '@shared/tokens/anatomy.stylex';
import { colors } from '@shared/tokens/colors.stylex';
import { fonts } from '@shared/tokens/fonts.stylex';
import * as stylex from '@stylexjs/stylex';

export const styles = stylex.create({
  overlay: {
    position: 'fixed',
    top: 0,
    left: 0,
    width: '100%',
    height: '100%',
    backgroundColor: 'rgba(0, 0, 0, 0.5)',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    zIndex: 1000,
    animationName: stylex.keyframes({
      '0%': {
        opacity: 0,
      },
      '100%': {
        opacity: 1,
      },
    }),
    animationDuration: '0.2s',
    animationTimingFunction: 'ease-out',
  },
  modalContainer: {
    background: colors.primaryBackground,
    width: '380px',
    borderRadius: '16px',
    padding: '0 28px',
    maxHeight: '90vh',
    overflow: 'auto',
    boxShadow: '0 2px 10px rgba(0, 0, 0, 0.1)',
    position: 'relative',
    animationName: stylex.keyframes({
      '0%': {
        opacity: 0,
        transform: 'translateY(-20px) scale(0.95)',
      },
      '100%': {
        opacity: 1,
        transform: 'translateY(0) scale(1)',
      },
    }),
    animationDuration: '0.3s',
    animationTimingFunction: 'ease-out',
  },
  closeButton: {
    position: 'absolute',
    top: '16px',
    right: '16px',
    background: 'none',
    border: 'none',
    padding: 0,
    cursor: 'pointer',
  },
  closeIcon: {
    fill: colors.tertiaryIcon,
  },
  container: {
    fontFamily: fonts.din2014Regular,
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    gap: anatomy['size-24'],
    paddingTop: anatomy['size-28'],
    paddingBottom: anatomy['size-40'],
  },
  description: {
    display: 'flex',
    flexDirection: 'column',
    gap: anatomy['size-8'],
    marginTop: anatomy['size-4'],
  },
  title: {
    fontFamily: fonts.din2014Demi,
    fontSize: typography['fontSizeHeading-4'],
    lineHeight: typography['lineHeightBody-1'],
    textAlign: 'center',
  },
  subTitle: {
    fontSize: typography['fontSizeCaption-1'],
    lineHeight: typography['lineHeightCaption-1'],
    color: colors.secondaryBackground,
    textAlign: 'center',
  },
  actions: {
    display: 'flex',
    gap: anatomy['size-8'],
    ':not(#__unused__) button': {
      width: '132px',
      fontSize: typography['fontSizeCaption-1'],
      lineHeight: typography['lineHeightCaption-1'],
    },
    ':not(#__unused__) > div > div': {
      height: 'auto',
    },
  },
  inputWrapper: {
    position: 'relative',
  },
  errorText: {
    position: 'absolute',
    bottom: '-20px',
    left: 0,
    color: colors.errorText,
    fontSize: typography['fontSizeCaption-3'],
    fontFamily: fonts.din2014Regular,
    fontWeight: typography.fontWeighRegular,
    lineHeight: '12px',
  },
});
